import React from 'react';
import classnames from 'classnames';
import { ApplicationView, useController } from '@aha-app/mvc';
import UserTriggerItems from '../../../SelectroV2/Templates/Users/UserTriggerItems';
import { SelectroController } from '@aha-app/selectro-v2';

interface TriggerTemplateProps {
  showInput?: boolean;
  focusing?: boolean;
  class?: string;
}

const TriggerTemplate: React.FC<TriggerTemplateProps> = ({ ...props }) => {
  const selectroController = useController(SelectroController);
  const { state, selectedItems } = selectroController;
  return (
    <div
      className={`${props.class} ${classnames({
        'react-in-place': true,
        'react-in-place__placeholder': true,
        'react-in-place--empty': !selectedItems?.length,
        'react-in-place--active': props.showInput || props.focusing,
        'react-in-place--disabled': state.disabled,
      })}`}
      tabIndex={1}
    >
      <div className='react-in-place__content'>
        <UserTriggerItems />
      </div>
    </div>
  );
};

export default ApplicationView(TriggerTemplate);
